import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeBadge() {
  return <div className="flex flex-col items-center bg-white p-8 rounded-lg shadow-md max-w-xl mx-auto" data-id="element-192">
      <div className="relative" data-id="element-193">
        <div className="w-24 h-24 rounded-full bg-purple-600 flex items-center justify-center mb-3" data-id="element-194">
          <ShieldCheckIcon className="w-12 h-12 text-white" data-id="element-195" />
        </div>
        <div className="absolute -top-2 -right-2 w-8 h-8 bg-white rounded-full flex items-center justify-center shadow-md" data-id="element-196">
          <span className="text-purple-600 text-lg font-bold" data-id="element-197">✓</span>
        </div>
      </div>
      <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-198">
        30-Day Gentle Guarantee
      </h3>
      <p className="text-gray-700 text-center max-w-md" data-id="element-199">
        We believe in this work deeply—and we want you to feel safe trying it.
        Try Unfreeze for 30 days. Go at your own pace. If it doesn't resonate
        with you—if your body says no, or you feel it's not the right fit—just
        email us and we'll refund you in full. No hassle. No hard feelings.
      </p>
      <p className="text-gray-700 text-center font-medium mt-2" data-id="element-200">
        This work only works when it feels right. That's what we honor.
      </p>
    </div>;
}